module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp12_9006.743d6f6f.png";